// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-share{width:800px}.edit-share .base .el-input{flex:1;height:24px}.edit-share .base .el-input input{height:100%}.edit-share .base .el-input .el-input__inner{font-size:14px;padding:2px;width:150px;height:24px;line-height:24px}.edit-share .base .el-textarea{flex:1;height:74px}.edit-share .base .el-textarea .el-textarea__inner{font-size:14px;padding:2px;height:74px}.edit-share .edit-item .el-radio-group{margin-left:10px}", ""]);
// Exports
module.exports = exports;
